import React, { useState, useEffect } from "react";
import "./MemoryGame.css";

const easyEmojis = ["🍎","🍌","🍇","🍉","🐶","🐱"];
const hardEmojis = ["🚀","🎮","📚","🎵","⚽","🏀","🌍","💡","🧩","🎲"];

// Load sound files (place them in your public folder or import them)
const correctSound = new Audio("/sounds/correct.mp3");
const wrongSound = new Audio("/sounds/wrong.wav");
const winSound = new Audio("/sounds/win.mp3");

function shuffleArray(array) {
  return [...array].sort(() => Math.random() - 0.5);
}

export default function MemoryGame() {
  const [cards, setCards] = useState([]);
  const [flipped, setFlipped] = useState([]);
  const [matched, setMatched] = useState([]);
  const [mode, setMode] = useState("easy");
  const [score, setScore] = useState(0);
  const [time, setTime] = useState(0);
  const [gameOver, setGameOver] = useState(false);

  useEffect(() => {
    const emojiSet = mode === "easy" ? easyEmojis : hardEmojis;
    const shuffled = shuffleArray([...emojiSet, ...emojiSet]);
    setCards(shuffled);
    setFlipped([]);
    setMatched([]);
    setScore(0);
    setTime(0);
    setGameOver(false);
  }, [mode]);

  useEffect(() => {
    let timer;
    if (!gameOver) {
      timer = setInterval(() => setTime((t) => t + 1), 1000);
    }
    return () => clearInterval(timer);
  }, [gameOver]);

  const handleFlip = (index) => {
    if (flipped.length === 2 || flipped.includes(index)) return;
    setFlipped([...flipped, index]);

    if (flipped.length === 1) {
      const firstIndex = flipped[0];
      if (cards[firstIndex] === cards[index]) {
        setMatched([...matched, cards[index]]);
        setScore(score + 10);
        correctSound.play(); // ✅ play correct sound
      } else {
        setScore(score - 2);
        wrongSound.play(); // ❌ play wrong sound
      }
      setTimeout(() => setFlipped([]), 1000);
    }
  };

  useEffect(() => {
    if (matched.length === (mode === "easy" ? easyEmojis.length : hardEmojis.length)) {
      setGameOver(true);
      winSound.play(); // 🎉 play win sound
    }
  }, [matched, mode]);

  return (
    <div className="game-container">
      <h1>🎯 Memory Game</h1>
      <div className="mode-buttons">
        <button onClick={() => setMode("easy")}>Under 12</button>
        <button onClick={() => setMode("hard")}>Above 12</button>
      </div>
      <div className="stats">
        <p>⏱ Time: {time}s</p>
        <p>⭐ Score: {score}</p>
      </div>
      <div className="card-grid">
        {cards.map((emoji, index) => (
          <div
            key={index}
            className={`card ${flipped.includes(index) || matched.includes(emoji) ? "flipped" : ""}`}
            onClick={() => handleFlip(index)}
          >
            <span>{flipped.includes(index) || matched.includes(emoji) ? emoji : "❓"}</span>
          </div>
        ))}
      </div>
      {gameOver && <h2>🎉 Game Over! Final Score: {score}</h2>}
    </div>
  );
}
